import {
  GUIDELINE_CREATE, GUIDELINE_SAVE_FAILURE, GUIDELINE_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    guidelines: []
  },
  getters: {
    guidelines: state => {
      return state.guidelines
    }
  },
  actions: {
    [GUIDELINE_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/guidelines', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GUIDELINE_SAVE_FAILURE, res.data)
            } else {
              commit(GUIDELINE_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [GUIDELINE_SAVE_FAILURE] (state, data) {
      console.log('GUIDELINE_SAVE_FAILURE')
    },
    [GUIDELINE_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline-new.js